module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundB.00053e4.eot";